export const SHAREHOLDERS_DECLARATION_STATUS = {
  SUBMITTED: 'submitted',
  PENDING: 'pending',
};
